import PropTypes from 'prop-types';
import React, { Suspense, useCallback, useState } from "react";

import { AzFormApplication, AzModal } from "@Development/ui-kit";
import { ApplicationContext } from '@product-site-frontend/shared';
import { navigate } from 'gatsby';
import store from "store2";
import {
  leasingFormDoneFromTID,
  leasingFormGoToLK,
  leasingFormGoToTid, leasingFormLoadFullForm,
} from "@product-site-frontend/account/src/utils/metrics";

LayoutApplicationContext.propTypes = {
  children: PropTypes.node,
};

export default function LayoutApplicationContext({ children, partnerSlug }) {
  const arenzaStorage = store.namespace('arenza');
  const EQUIPMENT_TYPE = "property_type";

  const [applicationOpen, setApplicationOpen] = useState(false);
  const [amount, setAmount] = useState('');

  const contextValue = {
    data: {
      amount,
      applicationOpen,
      inn: '',
      phone: '',
      full_name: '',
      email: '',
      promo_code: '',
    },
    setApplicationOpen,
    setAmount,
  };

  const closeApplicationDialog = useCallback(
    () => setApplicationOpen(false),
    [setApplicationOpen],
  );

  const handleSuccess = useCallback((submitResponse) => {
    navigate(`${process.env.GATSBY_ACCOUNT_URL}/?auth_token=${submitResponse.auth_token}`);
  }, []);

  return (
    <ApplicationContext.Provider value={contextValue}>
      {children}

      {applicationOpen && (
        <Suspense>
          <AzModal animationSlide={true} onClose={closeApplicationDialog} smallCloseZone={true}>
            <AzFormApplication
              channel={'partner_landing'}
              eventsLeasingFormDoneFromTID={leasingFormDoneFromTID}
              eventsLeasingFormGoToLK={leasingFormGoToLK}
              eventsLeasingFormGoToTid={leasingFormGoToTid}
              eventsLeasingFormLoadFullForm={leasingFormLoadFullForm}
              propertyType={arenzaStorage(EQUIPMENT_TYPE)}
              tidRedirectUrl={`${process.env.GATSBY_ACCOUNT_URL}/`}
              urlAccountClient={process.env.GATSBY_ACCOUNT_URL}
              urlFrontOfficeBackend={process.env.GATSBY_FRONTOFFICE_API}
              landing_slug={partnerSlug ? partnerSlug : undefined}
              landing_url={window?.location.href}
            />
          </AzModal>
        </Suspense>
      )}
    </ApplicationContext.Provider>
  );
}
